import React, { useState } from "react"
import DeleteModal from "components/Common/DeleteModal"
import { usePagination } from "hooks/usePagination"
import ResultHandler from "components/ResultHandler"
import PaginationHandler from "components/PaginationHandler"
import { deletePoll, getPolls } from "api/polls"
import TableHeaderHandler from "components/TableHeaderHandler"
import { PERMISSIONS } from "api/permissions"
import { useTranslation } from "react-i18next"
import { useResponse } from "hooks/useResponse"
import TableAction from "components/TableAction"
import EmptyData from "components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import CustomImage from "components/CustomImage"

export default function PollsTable() {
  const { t } = useTranslation()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
  } = usePagination(getPolls)

  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingPoll, setDeletingPoll] = useState(null)

  const { setData } = useResponse(deletePoll, () => {
    setShow(false)
    setDeletingPoll(null)
    setPayload({})
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingPoll })
  }

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.POLL_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="/add-poll"
      />

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th style={{ width: "20%" }}>{t("forms.Image")}</Th>
                <Th style={{ width: "50%" }}>{t("forms.Text")}</Th>
                <Th style={{ width: "30%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.polls.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>
                        <CustomImage src={row.cover_url} width="40px" height="40px" />
                      </Td>
                      <Td>{row.text}</Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          editPermission={PERMISSIONS.POLL_EDIT}
                          deletePermission={PERMISSIONS.POLL_DELETE}
                          type="poll"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingPoll}
                        />
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={response.data && response.data.polls.length === 0}
              msg="No Polls Found."
            />
          )}
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}
          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  )
}
